/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { RequestParameter } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class ContentManagementResourceService {

    protected basePath = 'https://dev.eeoc.gov/ecm';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object") {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param appname 
     * @param domain 
     * @param useremail 
     * @param userfirstname 
     * @param userlastname 
     * @param acctoffice 
     * @param addversion 
     * @param agency 
     * @param getdocid 
     * @param doctype 
     * @param documentCategory 
     * @param filename 
     * @param foldername 
     * @param isfepa 
     * @param islogactivity 
     * @param ispub 
     * @param notes 
     * @param securityCode 
     * @param showAllVersions 
     * @param showExactVersion 
     * @param subfoldername 
     * @param useFileNameForCompress 
     * @param userGroup 
     * @param userName 
     * @param userType 
     * @param version 
     * @param year 
     * @param additionalinfo 
     * @param isDisclosable 
     * @param appusercreatorfullname 
     * @param appusermodifybyfullname 
     * @param complainantname 
     * @param content 
     * @param mimetype 
     * @param copyfoldername 
     * @param destinationfoldername 
     * @param emailDisable 
     * @param encryption 
     * @param fedRelatedDateStr 
     * @param fepaofficecode 
     * @param foldernewname 
     * @param numofindref 
     * @param relatedDateStr 
     * @param releaseToIndicator 
     * @param title 
     * @param responseDueDate 
     * @param userEmail 
     * @param federalRequest 
     * @param destinationFolderName 
     * @param applicationUserLastModifyByFullName 
     * @param complainantName 
     * @param userFirstName 
     * @param userLastName 
     * @param privateRequest 
     * @param privateOrFepaRequest 
     * @param systemicRequest 
     * @param emaildisable 
     * @param prirelatedatestr 
     * @param releasetoindicator 
     * @param applicationName 
     * @param username 
     * @param eeocTrackingNumber 
     * @param domainName 
     * @param subCategory 
     * @param agencyCode 
     * @param federal 
     * @param agencyCaseNumber 
     * @param creationDateRange 
     * @param tabType 
     * @param accountableOfficeCode 
     * @param searchKeyWord 
     * @param subFolderName 
     * @param md715OrForm462 
     * @param application 
     * @param doccategory 
     * @param securitycode 
     * @param usergroup 
     * @param usertype 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addDocument(appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<object>;
    public addDocument(appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<object>>;
    public addDocument(appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<object>>;
    public addDocument(appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
        if (appname === null || appname === undefined) {
            throw new Error('Required parameter appname was null or undefined when calling addDocument.');
        }
        if (domain === null || domain === undefined) {
            throw new Error('Required parameter domain was null or undefined when calling addDocument.');
        }
        if (useremail === null || useremail === undefined) {
            throw new Error('Required parameter useremail was null or undefined when calling addDocument.');
        }
        if (userfirstname === null || userfirstname === undefined) {
            throw new Error('Required parameter userfirstname was null or undefined when calling addDocument.');
        }
        if (userlastname === null || userlastname === undefined) {
            throw new Error('Required parameter userlastname was null or undefined when calling addDocument.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/xml'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: this.encoder});
        }

        if (acctoffice !== undefined) {
            formParams = formParams.append('acctoffice', <any>acctoffice) as any || formParams;
        }
        if (addversion !== undefined) {
            formParams = formParams.append('addversion', <any>addversion) as any || formParams;
        }
        if (agency !== undefined) {
            formParams = formParams.append('agency', <any>agency) as any || formParams;
        }
        if (appname !== undefined) {
            formParams = formParams.append('appname', <any>appname) as any || formParams;
        }
        if (getdocid !== undefined) {
            formParams = formParams.append('getdocid', <any>getdocid) as any || formParams;
        }
        if (doctype !== undefined) {
            formParams = formParams.append('doctype', <any>doctype) as any || formParams;
        }
        if (documentCategory !== undefined) {
            formParams = formParams.append('documentCategory', <any>documentCategory) as any || formParams;
        }
        if (domain !== undefined) {
            formParams = formParams.append('domain', <any>domain) as any || formParams;
        }
        if (filename !== undefined) {
            formParams = formParams.append('filename', <any>filename) as any || formParams;
        }
        if (foldername !== undefined) {
            formParams = formParams.append('foldername', <any>foldername) as any || formParams;
        }
        if (isfepa !== undefined) {
            formParams = formParams.append('isfepa', <any>isfepa) as any || formParams;
        }
        if (islogactivity !== undefined) {
            formParams = formParams.append('islogactivity', <any>islogactivity) as any || formParams;
        }
        if (ispub !== undefined) {
            formParams = formParams.append('ispub', <any>ispub) as any || formParams;
        }
        if (notes !== undefined) {
            formParams = formParams.append('notes', <any>notes) as any || formParams;
        }
        if (securityCode !== undefined) {
            formParams = formParams.append('securityCode', <any>securityCode) as any || formParams;
        }
        if (showAllVersions !== undefined) {
            formParams = formParams.append('showAllVersions', <any>showAllVersions) as any || formParams;
        }
        if (showExactVersion !== undefined) {
            formParams = formParams.append('showExactVersion', <any>showExactVersion) as any || formParams;
        }
        if (subfoldername !== undefined) {
            formParams = formParams.append('subfoldername', <any>subfoldername) as any || formParams;
        }
        if (useFileNameForCompress !== undefined) {
            formParams = formParams.append('useFileNameForCompress', <any>useFileNameForCompress) as any || formParams;
        }
        if (userGroup !== undefined) {
            formParams = formParams.append('userGroup', <any>userGroup) as any || formParams;
        }
        if (userName !== undefined) {
            formParams = formParams.append('userName', <any>userName) as any || formParams;
        }
        if (userType !== undefined) {
            formParams = formParams.append('userType', <any>userType) as any || formParams;
        }
        if (version !== undefined) {
            formParams = formParams.append('version', <any>version) as any || formParams;
        }
        if (year !== undefined) {
            formParams = formParams.append('year', <any>year) as any || formParams;
        }
        if (additionalinfo !== undefined) {
            formParams = formParams.append('additionalinfo', <any>additionalinfo) as any || formParams;
        }
        if (isDisclosable !== undefined) {
            formParams = formParams.append('isDisclosable', <any>isDisclosable) as any || formParams;
        }
        if (appusercreatorfullname !== undefined) {
            formParams = formParams.append('appusercreatorfullname', <any>appusercreatorfullname) as any || formParams;
        }
        if (appusermodifybyfullname !== undefined) {
            formParams = formParams.append('appusermodifybyfullname', <any>appusermodifybyfullname) as any || formParams;
        }
        if (complainantname !== undefined) {
            formParams = formParams.append('complainantname', <any>complainantname) as any || formParams;
        }
        if (content !== undefined) {
            formParams = formParams.append('content', <any>content) as any || formParams;
        }
        if (mimetype !== undefined) {
            formParams = formParams.append('mimetype', <any>mimetype) as any || formParams;
        }
        if (copyfoldername !== undefined) {
            formParams = formParams.append('copyfoldername', <any>copyfoldername) as any || formParams;
        }
        if (destinationfoldername !== undefined) {
            formParams = formParams.append('destinationfoldername', <any>destinationfoldername) as any || formParams;
        }
        if (emailDisable !== undefined) {
            formParams = formParams.append('emailDisable', <any>emailDisable) as any || formParams;
        }
        if (encryption !== undefined) {
            formParams = formParams.append('encryption', <any>encryption) as any || formParams;
        }
        if (fedRelatedDateStr !== undefined) {
            formParams = formParams.append('fedRelatedDateStr', <any>fedRelatedDateStr) as any || formParams;
        }
        if (fepaofficecode !== undefined) {
            formParams = formParams.append('fepaofficecode', <any>fepaofficecode) as any || formParams;
        }
        if (foldernewname !== undefined) {
            formParams = formParams.append('foldernewname', <any>foldernewname) as any || formParams;
        }
        if (numofindref !== undefined) {
            formParams = formParams.append('numofindref', <any>numofindref) as any || formParams;
        }
        if (relatedDateStr !== undefined) {
            formParams = formParams.append('relatedDateStr', <any>relatedDateStr) as any || formParams;
        }
        if (releaseToIndicator !== undefined) {
            formParams = formParams.append('releaseToIndicator', <any>releaseToIndicator) as any || formParams;
        }
        if (title !== undefined) {
            formParams = formParams.append('title', <any>title) as any || formParams;
        }
        if (useremail !== undefined) {
            formParams = formParams.append('useremail', <any>useremail) as any || formParams;
        }
        if (userfirstname !== undefined) {
            formParams = formParams.append('userfirstname', <any>userfirstname) as any || formParams;
        }
        if (userlastname !== undefined) {
            formParams = formParams.append('userlastname', <any>userlastname) as any || formParams;
        }
        if (responseDueDate !== undefined) {
            formParams = formParams.append('responseDueDate', <any>responseDueDate) as any || formParams;
        }
        if (userEmail !== undefined) {
            formParams = formParams.append('userEmail', <any>userEmail) as any || formParams;
        }
        if (federalRequest !== undefined) {
            formParams = formParams.append('federalRequest', <any>federalRequest) as any || formParams;
        }
        if (destinationFolderName !== undefined) {
            formParams = formParams.append('destinationFolderName', <any>destinationFolderName) as any || formParams;
        }
        if (applicationUserLastModifyByFullName !== undefined) {
            formParams = formParams.append('applicationUserLastModifyByFullName', <any>applicationUserLastModifyByFullName) as any || formParams;
        }
        if (complainantName !== undefined) {
            formParams = formParams.append('complainantName', <any>complainantName) as any || formParams;
        }
        if (userFirstName !== undefined) {
            formParams = formParams.append('userFirstName', <any>userFirstName) as any || formParams;
        }
        if (userLastName !== undefined) {
            formParams = formParams.append('userLastName', <any>userLastName) as any || formParams;
        }
        if (privateRequest !== undefined) {
            formParams = formParams.append('privateRequest', <any>privateRequest) as any || formParams;
        }
        if (privateOrFepaRequest !== undefined) {
            formParams = formParams.append('privateOrFepaRequest', <any>privateOrFepaRequest) as any || formParams;
        }
        if (systemicRequest !== undefined) {
            formParams = formParams.append('systemicRequest', <any>systemicRequest) as any || formParams;
        }
        if (emaildisable !== undefined) {
            formParams = formParams.append('emaildisable', <any>emaildisable) as any || formParams;
        }
        if (prirelatedatestr !== undefined) {
            formParams = formParams.append('prirelatedatestr', <any>prirelatedatestr) as any || formParams;
        }
        if (releasetoindicator !== undefined) {
            formParams = formParams.append('releasetoindicator', <any>releasetoindicator) as any || formParams;
        }
        if (applicationName !== undefined) {
            formParams = formParams.append('applicationName', <any>applicationName) as any || formParams;
        }
        if (username !== undefined) {
            formParams = formParams.append('username', <any>username) as any || formParams;
        }
        if (eeocTrackingNumber !== undefined) {
            formParams = formParams.append('eeocTrackingNumber', <any>eeocTrackingNumber) as any || formParams;
        }
        if (domainName !== undefined) {
            formParams = formParams.append('domainName', <any>domainName) as any || formParams;
        }
        if (subCategory !== undefined) {
            formParams = formParams.append('subCategory', <any>subCategory) as any || formParams;
        }
        if (agencyCode !== undefined) {
            formParams = formParams.append('agencyCode', <any>agencyCode) as any || formParams;
        }
        if (federal !== undefined) {
            formParams = formParams.append('federal', <any>federal) as any || formParams;
        }
        if (agencyCaseNumber !== undefined) {
            formParams = formParams.append('agencyCaseNumber', <any>agencyCaseNumber) as any || formParams;
        }
        if (creationDateRange !== undefined) {
            formParams = formParams.append('creationDateRange', <any>creationDateRange) as any || formParams;
        }
        if (tabType !== undefined) {
            formParams = formParams.append('tabType', <any>tabType) as any || formParams;
        }
        if (accountableOfficeCode !== undefined) {
            formParams = formParams.append('accountableOfficeCode', <any>accountableOfficeCode) as any || formParams;
        }
        if (searchKeyWord !== undefined) {
            formParams = formParams.append('searchKeyWord', <any>searchKeyWord) as any || formParams;
        }
        if (subFolderName !== undefined) {
            formParams = formParams.append('subFolderName', <any>subFolderName) as any || formParams;
        }
        if (md715OrForm462 !== undefined) {
            formParams = formParams.append('md715OrForm462', <any>md715OrForm462) as any || formParams;
        }
        if (application !== undefined) {
            formParams = formParams.append('application', <any>application) as any || formParams;
        }
        if (doccategory !== undefined) {
            formParams = formParams.append('doccategory', <any>doccategory) as any || formParams;
        }
        if (securitycode !== undefined) {
            formParams = formParams.append('securitycode', <any>securitycode) as any || formParams;
        }
        if (usergroup !== undefined) {
            formParams = formParams.append('usergroup', <any>usergroup) as any || formParams;
        }
        if (usertype !== undefined) {
            formParams = formParams.append('usertype', <any>usertype) as any || formParams;
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<object>(`${this.configuration.basePath}/v3/documents`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param docid 
     * @param appname 
     * @param domain 
     * @param useremail 
     * @param userfirstname 
     * @param userlastname 
     * @param acctoffice 
     * @param addversion 
     * @param agency 
     * @param getdocid 
     * @param doctype 
     * @param documentCategory 
     * @param filename 
     * @param foldername 
     * @param isfepa 
     * @param islogactivity 
     * @param ispub 
     * @param notes 
     * @param securityCode 
     * @param showAllVersions 
     * @param showExactVersion 
     * @param subfoldername 
     * @param useFileNameForCompress 
     * @param userGroup 
     * @param userName 
     * @param userType 
     * @param version 
     * @param year 
     * @param additionalinfo 
     * @param isDisclosable 
     * @param appusercreatorfullname 
     * @param appusermodifybyfullname 
     * @param complainantname 
     * @param content 
     * @param mimetype 
     * @param copyfoldername 
     * @param destinationfoldername 
     * @param emailDisable 
     * @param encryption 
     * @param fedRelatedDateStr 
     * @param fepaofficecode 
     * @param foldernewname 
     * @param numofindref 
     * @param relatedDateStr 
     * @param releaseToIndicator 
     * @param title 
     * @param responseDueDate 
     * @param userEmail 
     * @param federalRequest 
     * @param destinationFolderName 
     * @param applicationUserLastModifyByFullName 
     * @param complainantName 
     * @param userFirstName 
     * @param userLastName 
     * @param privateRequest 
     * @param privateOrFepaRequest 
     * @param systemicRequest 
     * @param emaildisable 
     * @param prirelatedatestr 
     * @param releasetoindicator 
     * @param applicationName 
     * @param username 
     * @param eeocTrackingNumber 
     * @param domainName 
     * @param subCategory 
     * @param agencyCode 
     * @param federal 
     * @param agencyCaseNumber 
     * @param creationDateRange 
     * @param tabType 
     * @param accountableOfficeCode 
     * @param searchKeyWord 
     * @param subFolderName 
     * @param md715OrForm462 
     * @param application 
     * @param doccategory 
     * @param securitycode 
     * @param usergroup 
     * @param usertype 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public copyDocument(docid: string, appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<object>;
    public copyDocument(docid: string, appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<object>>;
    public copyDocument(docid: string, appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<object>>;
    public copyDocument(docid: string, appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {
        if (docid === null || docid === undefined) {
            throw new Error('Required parameter docid was null or undefined when calling copyDocument.');
        }
        if (appname === null || appname === undefined) {
            throw new Error('Required parameter appname was null or undefined when calling copyDocument.');
        }
        if (domain === null || domain === undefined) {
            throw new Error('Required parameter domain was null or undefined when calling copyDocument.');
        }
        if (useremail === null || useremail === undefined) {
            throw new Error('Required parameter useremail was null or undefined when calling copyDocument.');
        }
        if (userfirstname === null || userfirstname === undefined) {
            throw new Error('Required parameter userfirstname was null or undefined when calling copyDocument.');
        }
        if (userlastname === null || userlastname === undefined) {
            throw new Error('Required parameter userlastname was null or undefined when calling copyDocument.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: this.encoder});
        }

        if (acctoffice !== undefined) {
            formParams = formParams.append('acctoffice', <any>acctoffice) as any || formParams;
        }
        if (addversion !== undefined) {
            formParams = formParams.append('addversion', <any>addversion) as any || formParams;
        }
        if (agency !== undefined) {
            formParams = formParams.append('agency', <any>agency) as any || formParams;
        }
        if (appname !== undefined) {
            formParams = formParams.append('appname', <any>appname) as any || formParams;
        }
        if (getdocid !== undefined) {
            formParams = formParams.append('getdocid', <any>getdocid) as any || formParams;
        }
        if (doctype !== undefined) {
            formParams = formParams.append('doctype', <any>doctype) as any || formParams;
        }
        if (documentCategory !== undefined) {
            formParams = formParams.append('documentCategory', <any>documentCategory) as any || formParams;
        }
        if (domain !== undefined) {
            formParams = formParams.append('domain', <any>domain) as any || formParams;
        }
        if (filename !== undefined) {
            formParams = formParams.append('filename', <any>filename) as any || formParams;
        }
        if (foldername !== undefined) {
            formParams = formParams.append('foldername', <any>foldername) as any || formParams;
        }
        if (isfepa !== undefined) {
            formParams = formParams.append('isfepa', <any>isfepa) as any || formParams;
        }
        if (islogactivity !== undefined) {
            formParams = formParams.append('islogactivity', <any>islogactivity) as any || formParams;
        }
        if (ispub !== undefined) {
            formParams = formParams.append('ispub', <any>ispub) as any || formParams;
        }
        if (notes !== undefined) {
            formParams = formParams.append('notes', <any>notes) as any || formParams;
        }
        if (securityCode !== undefined) {
            formParams = formParams.append('securityCode', <any>securityCode) as any || formParams;
        }
        if (showAllVersions !== undefined) {
            formParams = formParams.append('showAllVersions', <any>showAllVersions) as any || formParams;
        }
        if (showExactVersion !== undefined) {
            formParams = formParams.append('showExactVersion', <any>showExactVersion) as any || formParams;
        }
        if (subfoldername !== undefined) {
            formParams = formParams.append('subfoldername', <any>subfoldername) as any || formParams;
        }
        if (useFileNameForCompress !== undefined) {
            formParams = formParams.append('useFileNameForCompress', <any>useFileNameForCompress) as any || formParams;
        }
        if (userGroup !== undefined) {
            formParams = formParams.append('userGroup', <any>userGroup) as any || formParams;
        }
        if (userName !== undefined) {
            formParams = formParams.append('userName', <any>userName) as any || formParams;
        }
        if (userType !== undefined) {
            formParams = formParams.append('userType', <any>userType) as any || formParams;
        }
        if (version !== undefined) {
            formParams = formParams.append('version', <any>version) as any || formParams;
        }
        if (year !== undefined) {
            formParams = formParams.append('year', <any>year) as any || formParams;
        }
        if (additionalinfo !== undefined) {
            formParams = formParams.append('additionalinfo', <any>additionalinfo) as any || formParams;
        }
        if (isDisclosable !== undefined) {
            formParams = formParams.append('isDisclosable', <any>isDisclosable) as any || formParams;
        }
        if (appusercreatorfullname !== undefined) {
            formParams = formParams.append('appusercreatorfullname', <any>appusercreatorfullname) as any || formParams;
        }
        if (appusermodifybyfullname !== undefined) {
            formParams = formParams.append('appusermodifybyfullname', <any>appusermodifybyfullname) as any || formParams;
        }
        if (complainantname !== undefined) {
            formParams = formParams.append('complainantname', <any>complainantname) as any || formParams;
        }
        if (content !== undefined) {
            formParams = formParams.append('content', <any>content) as any || formParams;
        }
        if (mimetype !== undefined) {
            formParams = formParams.append('mimetype', <any>mimetype) as any || formParams;
        }
        if (copyfoldername !== undefined) {
            formParams = formParams.append('copyfoldername', <any>copyfoldername) as any || formParams;
        }
        if (destinationfoldername !== undefined) {
            formParams = formParams.append('destinationfoldername', <any>destinationfoldername) as any || formParams;
        }
        if (emailDisable !== undefined) {
            formParams = formParams.append('emailDisable', <any>emailDisable) as any || formParams;
        }
        if (encryption !== undefined) {
            formParams = formParams.append('encryption', <any>encryption) as any || formParams;
        }
        if (fedRelatedDateStr !== undefined) {
            formParams = formParams.append('fedRelatedDateStr', <any>fedRelatedDateStr) as any || formParams;
        }
        if (fepaofficecode !== undefined) {
            formParams = formParams.append('fepaofficecode', <any>fepaofficecode) as any || formParams;
        }
        if (foldernewname !== undefined) {
            formParams = formParams.append('foldernewname', <any>foldernewname) as any || formParams;
        }
        if (numofindref !== undefined) {
            formParams = formParams.append('numofindref', <any>numofindref) as any || formParams;
        }
        if (relatedDateStr !== undefined) {
            formParams = formParams.append('relatedDateStr', <any>relatedDateStr) as any || formParams;
        }
        if (releaseToIndicator !== undefined) {
            formParams = formParams.append('releaseToIndicator', <any>releaseToIndicator) as any || formParams;
        }
        if (title !== undefined) {
            formParams = formParams.append('title', <any>title) as any || formParams;
        }
        if (useremail !== undefined) {
            formParams = formParams.append('useremail', <any>useremail) as any || formParams;
        }
        if (userfirstname !== undefined) {
            formParams = formParams.append('userfirstname', <any>userfirstname) as any || formParams;
        }
        if (userlastname !== undefined) {
            formParams = formParams.append('userlastname', <any>userlastname) as any || formParams;
        }
        if (responseDueDate !== undefined) {
            formParams = formParams.append('responseDueDate', <any>responseDueDate) as any || formParams;
        }
        if (userEmail !== undefined) {
            formParams = formParams.append('userEmail', <any>userEmail) as any || formParams;
        }
        if (federalRequest !== undefined) {
            formParams = formParams.append('federalRequest', <any>federalRequest) as any || formParams;
        }
        if (destinationFolderName !== undefined) {
            formParams = formParams.append('destinationFolderName', <any>destinationFolderName) as any || formParams;
        }
        if (applicationUserLastModifyByFullName !== undefined) {
            formParams = formParams.append('applicationUserLastModifyByFullName', <any>applicationUserLastModifyByFullName) as any || formParams;
        }
        if (complainantName !== undefined) {
            formParams = formParams.append('complainantName', <any>complainantName) as any || formParams;
        }
        if (userFirstName !== undefined) {
            formParams = formParams.append('userFirstName', <any>userFirstName) as any || formParams;
        }
        if (userLastName !== undefined) {
            formParams = formParams.append('userLastName', <any>userLastName) as any || formParams;
        }
        if (privateRequest !== undefined) {
            formParams = formParams.append('privateRequest', <any>privateRequest) as any || formParams;
        }
        if (privateOrFepaRequest !== undefined) {
            formParams = formParams.append('privateOrFepaRequest', <any>privateOrFepaRequest) as any || formParams;
        }
        if (systemicRequest !== undefined) {
            formParams = formParams.append('systemicRequest', <any>systemicRequest) as any || formParams;
        }
        if (emaildisable !== undefined) {
            formParams = formParams.append('emaildisable', <any>emaildisable) as any || formParams;
        }
        if (prirelatedatestr !== undefined) {
            formParams = formParams.append('prirelatedatestr', <any>prirelatedatestr) as any || formParams;
        }
        if (releasetoindicator !== undefined) {
            formParams = formParams.append('releasetoindicator', <any>releasetoindicator) as any || formParams;
        }
        if (applicationName !== undefined) {
            formParams = formParams.append('applicationName', <any>applicationName) as any || formParams;
        }
        if (username !== undefined) {
            formParams = formParams.append('username', <any>username) as any || formParams;
        }
        if (eeocTrackingNumber !== undefined) {
            formParams = formParams.append('eeocTrackingNumber', <any>eeocTrackingNumber) as any || formParams;
        }
        if (domainName !== undefined) {
            formParams = formParams.append('domainName', <any>domainName) as any || formParams;
        }
        if (subCategory !== undefined) {
            formParams = formParams.append('subCategory', <any>subCategory) as any || formParams;
        }
        if (agencyCode !== undefined) {
            formParams = formParams.append('agencyCode', <any>agencyCode) as any || formParams;
        }
        if (federal !== undefined) {
            formParams = formParams.append('federal', <any>federal) as any || formParams;
        }
        if (agencyCaseNumber !== undefined) {
            formParams = formParams.append('agencyCaseNumber', <any>agencyCaseNumber) as any || formParams;
        }
        if (creationDateRange !== undefined) {
            formParams = formParams.append('creationDateRange', <any>creationDateRange) as any || formParams;
        }
        if (tabType !== undefined) {
            formParams = formParams.append('tabType', <any>tabType) as any || formParams;
        }
        if (accountableOfficeCode !== undefined) {
            formParams = formParams.append('accountableOfficeCode', <any>accountableOfficeCode) as any || formParams;
        }
        if (searchKeyWord !== undefined) {
            formParams = formParams.append('searchKeyWord', <any>searchKeyWord) as any || formParams;
        }
        if (subFolderName !== undefined) {
            formParams = formParams.append('subFolderName', <any>subFolderName) as any || formParams;
        }
        if (md715OrForm462 !== undefined) {
            formParams = formParams.append('md715OrForm462', <any>md715OrForm462) as any || formParams;
        }
        if (application !== undefined) {
            formParams = formParams.append('application', <any>application) as any || formParams;
        }
        if (doccategory !== undefined) {
            formParams = formParams.append('doccategory', <any>doccategory) as any || formParams;
        }
        if (securitycode !== undefined) {
            formParams = formParams.append('securitycode', <any>securitycode) as any || formParams;
        }
        if (usergroup !== undefined) {
            formParams = formParams.append('usergroup', <any>usergroup) as any || formParams;
        }
        if (usertype !== undefined) {
            formParams = formParams.append('usertype', <any>usertype) as any || formParams;
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.put<object>(`${this.configuration.basePath}/v3/documents/copy/${encodeURIComponent(String(docid))}`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param docid 
     * @param deletemirror 
     * @param reason 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteDocument(docid: string, deletemirror?: string, reason?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<object>;
    public deleteDocument(docid: string, deletemirror?: string, reason?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<object>>;
    public deleteDocument(docid: string, deletemirror?: string, reason?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<object>>;
    public deleteDocument(docid: string, deletemirror?: string, reason?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {
        if (docid === null || docid === undefined) {
            throw new Error('Required parameter docid was null or undefined when calling deleteDocument.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (deletemirror !== undefined && deletemirror !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>deletemirror, 'deletemirror');
        }
        if (reason !== undefined && reason !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>reason, 'reason');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.delete<object>(`${this.configuration.basePath}/v3/documents/${encodeURIComponent(String(docid))}`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param folderid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteFolder(folderid: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain'}): Observable<object>;
    public deleteFolder(folderid: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain'}): Observable<HttpResponse<object>>;
    public deleteFolder(folderid: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain'}): Observable<HttpEvent<object>>;
    public deleteFolder(folderid: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain'}): Observable<any> {
        if (folderid === null || folderid === undefined) {
            throw new Error('Required parameter folderid was null or undefined when calling deleteFolder.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.delete<object>(`${this.configuration.basePath}/v3/folder/${encodeURIComponent(String(folderid))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param reqParam 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadDocument(reqParam: RequestParameter, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Blob>;
    public downloadDocument(reqParam: RequestParameter, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Blob>>;
    public downloadDocument(reqParam: RequestParameter, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Blob>>;
    public downloadDocument(reqParam: RequestParameter, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {
        if (reqParam === null || reqParam === undefined) {
            throw new Error('Required parameter reqParam was null or undefined when calling downloadDocument.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (reqParam !== undefined && reqParam !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>reqParam, 'reqParam');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/v3/documents/download`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param reqParam 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadMultipleDocument(reqParam: RequestParameter, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<Blob>;
    public downloadMultipleDocument(reqParam: RequestParameter, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<Blob>>;
    public downloadMultipleDocument(reqParam: RequestParameter, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<Blob>>;
    public downloadMultipleDocument(reqParam: RequestParameter, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {
        if (reqParam === null || reqParam === undefined) {
            throw new Error('Required parameter reqParam was null or undefined when calling downloadMultipleDocument.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (reqParam !== undefined && reqParam !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>reqParam, 'reqParam');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/v3/documents/download/zip`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param vo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findDocuments(vo: RequestParameter, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<object>;
    public findDocuments(vo: RequestParameter, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<object>>;
    public findDocuments(vo: RequestParameter, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<object>>;
    public findDocuments(vo: RequestParameter, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
        if (vo === null || vo === undefined) {
            throw new Error('Required parameter vo was null or undefined when calling findDocuments.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (vo !== undefined && vo !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>vo, 'vo');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/xml'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<object>(`${this.configuration.basePath}/v3/documents`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param docId 
     * @param vo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findDocumentsByDocId(docId: string, vo: RequestParameter, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<object>;
    public findDocumentsByDocId(docId: string, vo: RequestParameter, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<object>>;
    public findDocumentsByDocId(docId: string, vo: RequestParameter, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<object>>;
    public findDocumentsByDocId(docId: string, vo: RequestParameter, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
        if (docId === null || docId === undefined) {
            throw new Error('Required parameter docId was null or undefined when calling findDocumentsByDocId.');
        }
        if (vo === null || vo === undefined) {
            throw new Error('Required parameter vo was null or undefined when calling findDocumentsByDocId.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (vo !== undefined && vo !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>vo, 'vo');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/xml'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<object>(`${this.configuration.basePath}/v3/documents/${encodeURIComponent(String(docId))}`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param name 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findFolderIdByFolderName(name: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<object>;
    public findFolderIdByFolderName(name: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpResponse<object>>;
    public findFolderIdByFolderName(name: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<HttpEvent<object>>;
    public findFolderIdByFolderName(name: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/xml'}): Observable<any> {
        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling findFolderIdByFolderName.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/xml'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<object>(`${this.configuration.basePath}/v3/folder/${encodeURIComponent(String(name))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param documentId 
     * @param appname 
     * @param domain 
     * @param useremail 
     * @param userfirstname 
     * @param userlastname 
     * @param acctoffice 
     * @param addversion 
     * @param agency 
     * @param getdocid 
     * @param doctype 
     * @param documentCategory 
     * @param filename 
     * @param foldername 
     * @param isfepa 
     * @param islogactivity 
     * @param ispub 
     * @param notes 
     * @param securityCode 
     * @param showAllVersions 
     * @param showExactVersion 
     * @param subfoldername 
     * @param useFileNameForCompress 
     * @param userGroup 
     * @param userName 
     * @param userType 
     * @param version 
     * @param year 
     * @param additionalinfo 
     * @param isDisclosable 
     * @param appusercreatorfullname 
     * @param appusermodifybyfullname 
     * @param complainantname 
     * @param content 
     * @param mimetype 
     * @param copyfoldername 
     * @param destinationfoldername 
     * @param emailDisable 
     * @param encryption 
     * @param fedRelatedDateStr 
     * @param fepaofficecode 
     * @param foldernewname 
     * @param numofindref 
     * @param relatedDateStr 
     * @param releaseToIndicator 
     * @param title 
     * @param responseDueDate 
     * @param userEmail 
     * @param federalRequest 
     * @param destinationFolderName 
     * @param applicationUserLastModifyByFullName 
     * @param complainantName 
     * @param userFirstName 
     * @param userLastName 
     * @param privateRequest 
     * @param privateOrFepaRequest 
     * @param systemicRequest 
     * @param emaildisable 
     * @param prirelatedatestr 
     * @param releasetoindicator 
     * @param applicationName 
     * @param username 
     * @param eeocTrackingNumber 
     * @param domainName 
     * @param subCategory 
     * @param agencyCode 
     * @param federal 
     * @param agencyCaseNumber 
     * @param creationDateRange 
     * @param tabType 
     * @param accountableOfficeCode 
     * @param searchKeyWord 
     * @param subFolderName 
     * @param md715OrForm462 
     * @param application 
     * @param doccategory 
     * @param securitycode 
     * @param usergroup 
     * @param usertype 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public moveDocument(documentId: string, appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/xml' | 'application/json'}): Observable<object>;
    public moveDocument(documentId: string, appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/xml' | 'application/json'}): Observable<HttpResponse<object>>;
    public moveDocument(documentId: string, appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/xml' | 'application/json'}): Observable<HttpEvent<object>>;
    public moveDocument(documentId: string, appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/xml' | 'application/json'}): Observable<any> {
        if (documentId === null || documentId === undefined) {
            throw new Error('Required parameter documentId was null or undefined when calling moveDocument.');
        }
        if (appname === null || appname === undefined) {
            throw new Error('Required parameter appname was null or undefined when calling moveDocument.');
        }
        if (domain === null || domain === undefined) {
            throw new Error('Required parameter domain was null or undefined when calling moveDocument.');
        }
        if (useremail === null || useremail === undefined) {
            throw new Error('Required parameter useremail was null or undefined when calling moveDocument.');
        }
        if (userfirstname === null || userfirstname === undefined) {
            throw new Error('Required parameter userfirstname was null or undefined when calling moveDocument.');
        }
        if (userlastname === null || userlastname === undefined) {
            throw new Error('Required parameter userlastname was null or undefined when calling moveDocument.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/xml',
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: this.encoder});
        }

        if (acctoffice !== undefined) {
            formParams = formParams.append('acctoffice', <any>acctoffice) as any || formParams;
        }
        if (addversion !== undefined) {
            formParams = formParams.append('addversion', <any>addversion) as any || formParams;
        }
        if (agency !== undefined) {
            formParams = formParams.append('agency', <any>agency) as any || formParams;
        }
        if (appname !== undefined) {
            formParams = formParams.append('appname', <any>appname) as any || formParams;
        }
        if (getdocid !== undefined) {
            formParams = formParams.append('getdocid', <any>getdocid) as any || formParams;
        }
        if (doctype !== undefined) {
            formParams = formParams.append('doctype', <any>doctype) as any || formParams;
        }
        if (documentCategory !== undefined) {
            formParams = formParams.append('documentCategory', <any>documentCategory) as any || formParams;
        }
        if (domain !== undefined) {
            formParams = formParams.append('domain', <any>domain) as any || formParams;
        }
        if (filename !== undefined) {
            formParams = formParams.append('filename', <any>filename) as any || formParams;
        }
        if (foldername !== undefined) {
            formParams = formParams.append('foldername', <any>foldername) as any || formParams;
        }
        if (isfepa !== undefined) {
            formParams = formParams.append('isfepa', <any>isfepa) as any || formParams;
        }
        if (islogactivity !== undefined) {
            formParams = formParams.append('islogactivity', <any>islogactivity) as any || formParams;
        }
        if (ispub !== undefined) {
            formParams = formParams.append('ispub', <any>ispub) as any || formParams;
        }
        if (notes !== undefined) {
            formParams = formParams.append('notes', <any>notes) as any || formParams;
        }
        if (securityCode !== undefined) {
            formParams = formParams.append('securityCode', <any>securityCode) as any || formParams;
        }
        if (showAllVersions !== undefined) {
            formParams = formParams.append('showAllVersions', <any>showAllVersions) as any || formParams;
        }
        if (showExactVersion !== undefined) {
            formParams = formParams.append('showExactVersion', <any>showExactVersion) as any || formParams;
        }
        if (subfoldername !== undefined) {
            formParams = formParams.append('subfoldername', <any>subfoldername) as any || formParams;
        }
        if (useFileNameForCompress !== undefined) {
            formParams = formParams.append('useFileNameForCompress', <any>useFileNameForCompress) as any || formParams;
        }
        if (userGroup !== undefined) {
            formParams = formParams.append('userGroup', <any>userGroup) as any || formParams;
        }
        if (userName !== undefined) {
            formParams = formParams.append('userName', <any>userName) as any || formParams;
        }
        if (userType !== undefined) {
            formParams = formParams.append('userType', <any>userType) as any || formParams;
        }
        if (version !== undefined) {
            formParams = formParams.append('version', <any>version) as any || formParams;
        }
        if (year !== undefined) {
            formParams = formParams.append('year', <any>year) as any || formParams;
        }
        if (additionalinfo !== undefined) {
            formParams = formParams.append('additionalinfo', <any>additionalinfo) as any || formParams;
        }
        if (isDisclosable !== undefined) {
            formParams = formParams.append('isDisclosable', <any>isDisclosable) as any || formParams;
        }
        if (appusercreatorfullname !== undefined) {
            formParams = formParams.append('appusercreatorfullname', <any>appusercreatorfullname) as any || formParams;
        }
        if (appusermodifybyfullname !== undefined) {
            formParams = formParams.append('appusermodifybyfullname', <any>appusermodifybyfullname) as any || formParams;
        }
        if (complainantname !== undefined) {
            formParams = formParams.append('complainantname', <any>complainantname) as any || formParams;
        }
        if (content !== undefined) {
            formParams = formParams.append('content', <any>content) as any || formParams;
        }
        if (mimetype !== undefined) {
            formParams = formParams.append('mimetype', <any>mimetype) as any || formParams;
        }
        if (copyfoldername !== undefined) {
            formParams = formParams.append('copyfoldername', <any>copyfoldername) as any || formParams;
        }
        if (destinationfoldername !== undefined) {
            formParams = formParams.append('destinationfoldername', <any>destinationfoldername) as any || formParams;
        }
        if (emailDisable !== undefined) {
            formParams = formParams.append('emailDisable', <any>emailDisable) as any || formParams;
        }
        if (encryption !== undefined) {
            formParams = formParams.append('encryption', <any>encryption) as any || formParams;
        }
        if (fedRelatedDateStr !== undefined) {
            formParams = formParams.append('fedRelatedDateStr', <any>fedRelatedDateStr) as any || formParams;
        }
        if (fepaofficecode !== undefined) {
            formParams = formParams.append('fepaofficecode', <any>fepaofficecode) as any || formParams;
        }
        if (foldernewname !== undefined) {
            formParams = formParams.append('foldernewname', <any>foldernewname) as any || formParams;
        }
        if (numofindref !== undefined) {
            formParams = formParams.append('numofindref', <any>numofindref) as any || formParams;
        }
        if (relatedDateStr !== undefined) {
            formParams = formParams.append('relatedDateStr', <any>relatedDateStr) as any || formParams;
        }
        if (releaseToIndicator !== undefined) {
            formParams = formParams.append('releaseToIndicator', <any>releaseToIndicator) as any || formParams;
        }
        if (title !== undefined) {
            formParams = formParams.append('title', <any>title) as any || formParams;
        }
        if (useremail !== undefined) {
            formParams = formParams.append('useremail', <any>useremail) as any || formParams;
        }
        if (userfirstname !== undefined) {
            formParams = formParams.append('userfirstname', <any>userfirstname) as any || formParams;
        }
        if (userlastname !== undefined) {
            formParams = formParams.append('userlastname', <any>userlastname) as any || formParams;
        }
        if (responseDueDate !== undefined) {
            formParams = formParams.append('responseDueDate', <any>responseDueDate) as any || formParams;
        }
        if (userEmail !== undefined) {
            formParams = formParams.append('userEmail', <any>userEmail) as any || formParams;
        }
        if (federalRequest !== undefined) {
            formParams = formParams.append('federalRequest', <any>federalRequest) as any || formParams;
        }
        if (destinationFolderName !== undefined) {
            formParams = formParams.append('destinationFolderName', <any>destinationFolderName) as any || formParams;
        }
        if (applicationUserLastModifyByFullName !== undefined) {
            formParams = formParams.append('applicationUserLastModifyByFullName', <any>applicationUserLastModifyByFullName) as any || formParams;
        }
        if (complainantName !== undefined) {
            formParams = formParams.append('complainantName', <any>complainantName) as any || formParams;
        }
        if (userFirstName !== undefined) {
            formParams = formParams.append('userFirstName', <any>userFirstName) as any || formParams;
        }
        if (userLastName !== undefined) {
            formParams = formParams.append('userLastName', <any>userLastName) as any || formParams;
        }
        if (privateRequest !== undefined) {
            formParams = formParams.append('privateRequest', <any>privateRequest) as any || formParams;
        }
        if (privateOrFepaRequest !== undefined) {
            formParams = formParams.append('privateOrFepaRequest', <any>privateOrFepaRequest) as any || formParams;
        }
        if (systemicRequest !== undefined) {
            formParams = formParams.append('systemicRequest', <any>systemicRequest) as any || formParams;
        }
        if (emaildisable !== undefined) {
            formParams = formParams.append('emaildisable', <any>emaildisable) as any || formParams;
        }
        if (prirelatedatestr !== undefined) {
            formParams = formParams.append('prirelatedatestr', <any>prirelatedatestr) as any || formParams;
        }
        if (releasetoindicator !== undefined) {
            formParams = formParams.append('releasetoindicator', <any>releasetoindicator) as any || formParams;
        }
        if (applicationName !== undefined) {
            formParams = formParams.append('applicationName', <any>applicationName) as any || formParams;
        }
        if (username !== undefined) {
            formParams = formParams.append('username', <any>username) as any || formParams;
        }
        if (eeocTrackingNumber !== undefined) {
            formParams = formParams.append('eeocTrackingNumber', <any>eeocTrackingNumber) as any || formParams;
        }
        if (domainName !== undefined) {
            formParams = formParams.append('domainName', <any>domainName) as any || formParams;
        }
        if (subCategory !== undefined) {
            formParams = formParams.append('subCategory', <any>subCategory) as any || formParams;
        }
        if (agencyCode !== undefined) {
            formParams = formParams.append('agencyCode', <any>agencyCode) as any || formParams;
        }
        if (federal !== undefined) {
            formParams = formParams.append('federal', <any>federal) as any || formParams;
        }
        if (agencyCaseNumber !== undefined) {
            formParams = formParams.append('agencyCaseNumber', <any>agencyCaseNumber) as any || formParams;
        }
        if (creationDateRange !== undefined) {
            formParams = formParams.append('creationDateRange', <any>creationDateRange) as any || formParams;
        }
        if (tabType !== undefined) {
            formParams = formParams.append('tabType', <any>tabType) as any || formParams;
        }
        if (accountableOfficeCode !== undefined) {
            formParams = formParams.append('accountableOfficeCode', <any>accountableOfficeCode) as any || formParams;
        }
        if (searchKeyWord !== undefined) {
            formParams = formParams.append('searchKeyWord', <any>searchKeyWord) as any || formParams;
        }
        if (subFolderName !== undefined) {
            formParams = formParams.append('subFolderName', <any>subFolderName) as any || formParams;
        }
        if (md715OrForm462 !== undefined) {
            formParams = formParams.append('md715OrForm462', <any>md715OrForm462) as any || formParams;
        }
        if (application !== undefined) {
            formParams = formParams.append('application', <any>application) as any || formParams;
        }
        if (doccategory !== undefined) {
            formParams = formParams.append('doccategory', <any>doccategory) as any || formParams;
        }
        if (securitycode !== undefined) {
            formParams = formParams.append('securitycode', <any>securitycode) as any || formParams;
        }
        if (usergroup !== undefined) {
            formParams = formParams.append('usergroup', <any>usergroup) as any || formParams;
        }
        if (usertype !== undefined) {
            formParams = formParams.append('usertype', <any>usertype) as any || formParams;
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.put<object>(`${this.configuration.basePath}/v3/documents/move/${encodeURIComponent(String(documentId))}`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param documentId 
     * @param appname 
     * @param domain 
     * @param useremail 
     * @param userfirstname 
     * @param userlastname 
     * @param acctoffice 
     * @param addversion 
     * @param agency 
     * @param getdocid 
     * @param doctype 
     * @param documentCategory 
     * @param filename 
     * @param foldername 
     * @param isfepa 
     * @param islogactivity 
     * @param ispub 
     * @param notes 
     * @param securityCode 
     * @param showAllVersions 
     * @param showExactVersion 
     * @param subfoldername 
     * @param useFileNameForCompress 
     * @param userGroup 
     * @param userName 
     * @param userType 
     * @param version 
     * @param year 
     * @param additionalinfo 
     * @param isDisclosable 
     * @param appusercreatorfullname 
     * @param appusermodifybyfullname 
     * @param complainantname 
     * @param content 
     * @param mimetype 
     * @param copyfoldername 
     * @param destinationfoldername 
     * @param emailDisable 
     * @param encryption 
     * @param fedRelatedDateStr 
     * @param fepaofficecode 
     * @param foldernewname 
     * @param numofindref 
     * @param relatedDateStr 
     * @param releaseToIndicator 
     * @param title 
     * @param responseDueDate 
     * @param userEmail 
     * @param federalRequest 
     * @param destinationFolderName 
     * @param applicationUserLastModifyByFullName 
     * @param complainantName 
     * @param userFirstName 
     * @param userLastName 
     * @param privateRequest 
     * @param privateOrFepaRequest 
     * @param systemicRequest 
     * @param emaildisable 
     * @param prirelatedatestr 
     * @param releasetoindicator 
     * @param applicationName 
     * @param username 
     * @param eeocTrackingNumber 
     * @param domainName 
     * @param subCategory 
     * @param agencyCode 
     * @param federal 
     * @param agencyCaseNumber 
     * @param creationDateRange 
     * @param tabType 
     * @param accountableOfficeCode 
     * @param searchKeyWord 
     * @param subFolderName 
     * @param md715OrForm462 
     * @param application 
     * @param doccategory 
     * @param securitycode 
     * @param usergroup 
     * @param usertype 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public moveDocumentToDeletedFolder(documentId: string, appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/xml' | 'application/json'}): Observable<object>;
    public moveDocumentToDeletedFolder(documentId: string, appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/xml' | 'application/json'}): Observable<HttpResponse<object>>;
    public moveDocumentToDeletedFolder(documentId: string, appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/xml' | 'application/json'}): Observable<HttpEvent<object>>;
    public moveDocumentToDeletedFolder(documentId: string, appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/xml' | 'application/json'}): Observable<any> {
        if (documentId === null || documentId === undefined) {
            throw new Error('Required parameter documentId was null or undefined when calling moveDocumentToDeletedFolder.');
        }
        if (appname === null || appname === undefined) {
            throw new Error('Required parameter appname was null or undefined when calling moveDocumentToDeletedFolder.');
        }
        if (domain === null || domain === undefined) {
            throw new Error('Required parameter domain was null or undefined when calling moveDocumentToDeletedFolder.');
        }
        if (useremail === null || useremail === undefined) {
            throw new Error('Required parameter useremail was null or undefined when calling moveDocumentToDeletedFolder.');
        }
        if (userfirstname === null || userfirstname === undefined) {
            throw new Error('Required parameter userfirstname was null or undefined when calling moveDocumentToDeletedFolder.');
        }
        if (userlastname === null || userlastname === undefined) {
            throw new Error('Required parameter userlastname was null or undefined when calling moveDocumentToDeletedFolder.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/xml',
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: this.encoder});
        }

        if (acctoffice !== undefined) {
            formParams = formParams.append('acctoffice', <any>acctoffice) as any || formParams;
        }
        if (addversion !== undefined) {
            formParams = formParams.append('addversion', <any>addversion) as any || formParams;
        }
        if (agency !== undefined) {
            formParams = formParams.append('agency', <any>agency) as any || formParams;
        }
        if (appname !== undefined) {
            formParams = formParams.append('appname', <any>appname) as any || formParams;
        }
        if (getdocid !== undefined) {
            formParams = formParams.append('getdocid', <any>getdocid) as any || formParams;
        }
        if (doctype !== undefined) {
            formParams = formParams.append('doctype', <any>doctype) as any || formParams;
        }
        if (documentCategory !== undefined) {
            formParams = formParams.append('documentCategory', <any>documentCategory) as any || formParams;
        }
        if (domain !== undefined) {
            formParams = formParams.append('domain', <any>domain) as any || formParams;
        }
        if (filename !== undefined) {
            formParams = formParams.append('filename', <any>filename) as any || formParams;
        }
        if (foldername !== undefined) {
            formParams = formParams.append('foldername', <any>foldername) as any || formParams;
        }
        if (isfepa !== undefined) {
            formParams = formParams.append('isfepa', <any>isfepa) as any || formParams;
        }
        if (islogactivity !== undefined) {
            formParams = formParams.append('islogactivity', <any>islogactivity) as any || formParams;
        }
        if (ispub !== undefined) {
            formParams = formParams.append('ispub', <any>ispub) as any || formParams;
        }
        if (notes !== undefined) {
            formParams = formParams.append('notes', <any>notes) as any || formParams;
        }
        if (securityCode !== undefined) {
            formParams = formParams.append('securityCode', <any>securityCode) as any || formParams;
        }
        if (showAllVersions !== undefined) {
            formParams = formParams.append('showAllVersions', <any>showAllVersions) as any || formParams;
        }
        if (showExactVersion !== undefined) {
            formParams = formParams.append('showExactVersion', <any>showExactVersion) as any || formParams;
        }
        if (subfoldername !== undefined) {
            formParams = formParams.append('subfoldername', <any>subfoldername) as any || formParams;
        }
        if (useFileNameForCompress !== undefined) {
            formParams = formParams.append('useFileNameForCompress', <any>useFileNameForCompress) as any || formParams;
        }
        if (userGroup !== undefined) {
            formParams = formParams.append('userGroup', <any>userGroup) as any || formParams;
        }
        if (userName !== undefined) {
            formParams = formParams.append('userName', <any>userName) as any || formParams;
        }
        if (userType !== undefined) {
            formParams = formParams.append('userType', <any>userType) as any || formParams;
        }
        if (version !== undefined) {
            formParams = formParams.append('version', <any>version) as any || formParams;
        }
        if (year !== undefined) {
            formParams = formParams.append('year', <any>year) as any || formParams;
        }
        if (additionalinfo !== undefined) {
            formParams = formParams.append('additionalinfo', <any>additionalinfo) as any || formParams;
        }
        if (isDisclosable !== undefined) {
            formParams = formParams.append('isDisclosable', <any>isDisclosable) as any || formParams;
        }
        if (appusercreatorfullname !== undefined) {
            formParams = formParams.append('appusercreatorfullname', <any>appusercreatorfullname) as any || formParams;
        }
        if (appusermodifybyfullname !== undefined) {
            formParams = formParams.append('appusermodifybyfullname', <any>appusermodifybyfullname) as any || formParams;
        }
        if (complainantname !== undefined) {
            formParams = formParams.append('complainantname', <any>complainantname) as any || formParams;
        }
        if (content !== undefined) {
            formParams = formParams.append('content', <any>content) as any || formParams;
        }
        if (mimetype !== undefined) {
            formParams = formParams.append('mimetype', <any>mimetype) as any || formParams;
        }
        if (copyfoldername !== undefined) {
            formParams = formParams.append('copyfoldername', <any>copyfoldername) as any || formParams;
        }
        if (destinationfoldername !== undefined) {
            formParams = formParams.append('destinationfoldername', <any>destinationfoldername) as any || formParams;
        }
        if (emailDisable !== undefined) {
            formParams = formParams.append('emailDisable', <any>emailDisable) as any || formParams;
        }
        if (encryption !== undefined) {
            formParams = formParams.append('encryption', <any>encryption) as any || formParams;
        }
        if (fedRelatedDateStr !== undefined) {
            formParams = formParams.append('fedRelatedDateStr', <any>fedRelatedDateStr) as any || formParams;
        }
        if (fepaofficecode !== undefined) {
            formParams = formParams.append('fepaofficecode', <any>fepaofficecode) as any || formParams;
        }
        if (foldernewname !== undefined) {
            formParams = formParams.append('foldernewname', <any>foldernewname) as any || formParams;
        }
        if (numofindref !== undefined) {
            formParams = formParams.append('numofindref', <any>numofindref) as any || formParams;
        }
        if (relatedDateStr !== undefined) {
            formParams = formParams.append('relatedDateStr', <any>relatedDateStr) as any || formParams;
        }
        if (releaseToIndicator !== undefined) {
            formParams = formParams.append('releaseToIndicator', <any>releaseToIndicator) as any || formParams;
        }
        if (title !== undefined) {
            formParams = formParams.append('title', <any>title) as any || formParams;
        }
        if (useremail !== undefined) {
            formParams = formParams.append('useremail', <any>useremail) as any || formParams;
        }
        if (userfirstname !== undefined) {
            formParams = formParams.append('userfirstname', <any>userfirstname) as any || formParams;
        }
        if (userlastname !== undefined) {
            formParams = formParams.append('userlastname', <any>userlastname) as any || formParams;
        }
        if (responseDueDate !== undefined) {
            formParams = formParams.append('responseDueDate', <any>responseDueDate) as any || formParams;
        }
        if (userEmail !== undefined) {
            formParams = formParams.append('userEmail', <any>userEmail) as any || formParams;
        }
        if (federalRequest !== undefined) {
            formParams = formParams.append('federalRequest', <any>federalRequest) as any || formParams;
        }
        if (destinationFolderName !== undefined) {
            formParams = formParams.append('destinationFolderName', <any>destinationFolderName) as any || formParams;
        }
        if (applicationUserLastModifyByFullName !== undefined) {
            formParams = formParams.append('applicationUserLastModifyByFullName', <any>applicationUserLastModifyByFullName) as any || formParams;
        }
        if (complainantName !== undefined) {
            formParams = formParams.append('complainantName', <any>complainantName) as any || formParams;
        }
        if (userFirstName !== undefined) {
            formParams = formParams.append('userFirstName', <any>userFirstName) as any || formParams;
        }
        if (userLastName !== undefined) {
            formParams = formParams.append('userLastName', <any>userLastName) as any || formParams;
        }
        if (privateRequest !== undefined) {
            formParams = formParams.append('privateRequest', <any>privateRequest) as any || formParams;
        }
        if (privateOrFepaRequest !== undefined) {
            formParams = formParams.append('privateOrFepaRequest', <any>privateOrFepaRequest) as any || formParams;
        }
        if (systemicRequest !== undefined) {
            formParams = formParams.append('systemicRequest', <any>systemicRequest) as any || formParams;
        }
        if (emaildisable !== undefined) {
            formParams = formParams.append('emaildisable', <any>emaildisable) as any || formParams;
        }
        if (prirelatedatestr !== undefined) {
            formParams = formParams.append('prirelatedatestr', <any>prirelatedatestr) as any || formParams;
        }
        if (releasetoindicator !== undefined) {
            formParams = formParams.append('releasetoindicator', <any>releasetoindicator) as any || formParams;
        }
        if (applicationName !== undefined) {
            formParams = formParams.append('applicationName', <any>applicationName) as any || formParams;
        }
        if (username !== undefined) {
            formParams = formParams.append('username', <any>username) as any || formParams;
        }
        if (eeocTrackingNumber !== undefined) {
            formParams = formParams.append('eeocTrackingNumber', <any>eeocTrackingNumber) as any || formParams;
        }
        if (domainName !== undefined) {
            formParams = formParams.append('domainName', <any>domainName) as any || formParams;
        }
        if (subCategory !== undefined) {
            formParams = formParams.append('subCategory', <any>subCategory) as any || formParams;
        }
        if (agencyCode !== undefined) {
            formParams = formParams.append('agencyCode', <any>agencyCode) as any || formParams;
        }
        if (federal !== undefined) {
            formParams = formParams.append('federal', <any>federal) as any || formParams;
        }
        if (agencyCaseNumber !== undefined) {
            formParams = formParams.append('agencyCaseNumber', <any>agencyCaseNumber) as any || formParams;
        }
        if (creationDateRange !== undefined) {
            formParams = formParams.append('creationDateRange', <any>creationDateRange) as any || formParams;
        }
        if (tabType !== undefined) {
            formParams = formParams.append('tabType', <any>tabType) as any || formParams;
        }
        if (accountableOfficeCode !== undefined) {
            formParams = formParams.append('accountableOfficeCode', <any>accountableOfficeCode) as any || formParams;
        }
        if (searchKeyWord !== undefined) {
            formParams = formParams.append('searchKeyWord', <any>searchKeyWord) as any || formParams;
        }
        if (subFolderName !== undefined) {
            formParams = formParams.append('subFolderName', <any>subFolderName) as any || formParams;
        }
        if (md715OrForm462 !== undefined) {
            formParams = formParams.append('md715OrForm462', <any>md715OrForm462) as any || formParams;
        }
        if (application !== undefined) {
            formParams = formParams.append('application', <any>application) as any || formParams;
        }
        if (doccategory !== undefined) {
            formParams = formParams.append('doccategory', <any>doccategory) as any || formParams;
        }
        if (securitycode !== undefined) {
            formParams = formParams.append('securitycode', <any>securitycode) as any || formParams;
        }
        if (usergroup !== undefined) {
            formParams = formParams.append('usergroup', <any>usergroup) as any || formParams;
        }
        if (usertype !== undefined) {
            formParams = formParams.append('usertype', <any>usertype) as any || formParams;
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.put<object>(`${this.configuration.basePath}/v3/documents/move/${encodeURIComponent(String(documentId))}/deletefolder`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param folderName 
     * @param destination 
     * @param domainName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public moveFolder(folderName: string, destination: string, domainName: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain'}): Observable<object>;
    public moveFolder(folderName: string, destination: string, domainName: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain'}): Observable<HttpResponse<object>>;
    public moveFolder(folderName: string, destination: string, domainName: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain'}): Observable<HttpEvent<object>>;
    public moveFolder(folderName: string, destination: string, domainName: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain'}): Observable<any> {
        if (folderName === null || folderName === undefined) {
            throw new Error('Required parameter folderName was null or undefined when calling moveFolder.');
        }
        if (destination === null || destination === undefined) {
            throw new Error('Required parameter destination was null or undefined when calling moveFolder.');
        }
        if (domainName === null || domainName === undefined) {
            throw new Error('Required parameter domainName was null or undefined when calling moveFolder.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.put<object>(`${this.configuration.basePath}/v3/folder/${encodeURIComponent(String(folderName))}/move/${encodeURIComponent(String(destination))}/domain/${encodeURIComponent(String(domainName))}`,
            null,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param docid 
     * @param appname 
     * @param domain 
     * @param useremail 
     * @param userfirstname 
     * @param userlastname 
     * @param acctoffice 
     * @param addversion 
     * @param agency 
     * @param getdocid 
     * @param doctype 
     * @param documentCategory 
     * @param filename 
     * @param foldername 
     * @param isfepa 
     * @param islogactivity 
     * @param ispub 
     * @param notes 
     * @param securityCode 
     * @param showAllVersions 
     * @param showExactVersion 
     * @param subfoldername 
     * @param useFileNameForCompress 
     * @param userGroup 
     * @param userName 
     * @param userType 
     * @param version 
     * @param year 
     * @param additionalinfo 
     * @param isDisclosable 
     * @param appusercreatorfullname 
     * @param appusermodifybyfullname 
     * @param complainantname 
     * @param content 
     * @param mimetype 
     * @param copyfoldername 
     * @param destinationfoldername 
     * @param emailDisable 
     * @param encryption 
     * @param fedRelatedDateStr 
     * @param fepaofficecode 
     * @param foldernewname 
     * @param numofindref 
     * @param relatedDateStr 
     * @param releaseToIndicator 
     * @param title 
     * @param responseDueDate 
     * @param userEmail 
     * @param federalRequest 
     * @param destinationFolderName 
     * @param applicationUserLastModifyByFullName 
     * @param complainantName 
     * @param userFirstName 
     * @param userLastName 
     * @param privateRequest 
     * @param privateOrFepaRequest 
     * @param systemicRequest 
     * @param emaildisable 
     * @param prirelatedatestr 
     * @param releasetoindicator 
     * @param applicationName 
     * @param username 
     * @param eeocTrackingNumber 
     * @param domainName 
     * @param subCategory 
     * @param agencyCode 
     * @param federal 
     * @param agencyCaseNumber 
     * @param creationDateRange 
     * @param tabType 
     * @param accountableOfficeCode 
     * @param searchKeyWord 
     * @param subFolderName 
     * @param md715OrForm462 
     * @param application 
     * @param doccategory 
     * @param securitycode 
     * @param usergroup 
     * @param usertype 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public retractDocument(docid: string, appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<object>;
    public retractDocument(docid: string, appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<object>>;
    public retractDocument(docid: string, appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<object>>;
    public retractDocument(docid: string, appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {
        if (docid === null || docid === undefined) {
            throw new Error('Required parameter docid was null or undefined when calling retractDocument.');
        }
        if (appname === null || appname === undefined) {
            throw new Error('Required parameter appname was null or undefined when calling retractDocument.');
        }
        if (domain === null || domain === undefined) {
            throw new Error('Required parameter domain was null or undefined when calling retractDocument.');
        }
        if (useremail === null || useremail === undefined) {
            throw new Error('Required parameter useremail was null or undefined when calling retractDocument.');
        }
        if (userfirstname === null || userfirstname === undefined) {
            throw new Error('Required parameter userfirstname was null or undefined when calling retractDocument.');
        }
        if (userlastname === null || userlastname === undefined) {
            throw new Error('Required parameter userlastname was null or undefined when calling retractDocument.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: this.encoder});
        }

        if (acctoffice !== undefined) {
            formParams = formParams.append('acctoffice', <any>acctoffice) as any || formParams;
        }
        if (addversion !== undefined) {
            formParams = formParams.append('addversion', <any>addversion) as any || formParams;
        }
        if (agency !== undefined) {
            formParams = formParams.append('agency', <any>agency) as any || formParams;
        }
        if (appname !== undefined) {
            formParams = formParams.append('appname', <any>appname) as any || formParams;
        }
        if (getdocid !== undefined) {
            formParams = formParams.append('getdocid', <any>getdocid) as any || formParams;
        }
        if (doctype !== undefined) {
            formParams = formParams.append('doctype', <any>doctype) as any || formParams;
        }
        if (documentCategory !== undefined) {
            formParams = formParams.append('documentCategory', <any>documentCategory) as any || formParams;
        }
        if (domain !== undefined) {
            formParams = formParams.append('domain', <any>domain) as any || formParams;
        }
        if (filename !== undefined) {
            formParams = formParams.append('filename', <any>filename) as any || formParams;
        }
        if (foldername !== undefined) {
            formParams = formParams.append('foldername', <any>foldername) as any || formParams;
        }
        if (isfepa !== undefined) {
            formParams = formParams.append('isfepa', <any>isfepa) as any || formParams;
        }
        if (islogactivity !== undefined) {
            formParams = formParams.append('islogactivity', <any>islogactivity) as any || formParams;
        }
        if (ispub !== undefined) {
            formParams = formParams.append('ispub', <any>ispub) as any || formParams;
        }
        if (notes !== undefined) {
            formParams = formParams.append('notes', <any>notes) as any || formParams;
        }
        if (securityCode !== undefined) {
            formParams = formParams.append('securityCode', <any>securityCode) as any || formParams;
        }
        if (showAllVersions !== undefined) {
            formParams = formParams.append('showAllVersions', <any>showAllVersions) as any || formParams;
        }
        if (showExactVersion !== undefined) {
            formParams = formParams.append('showExactVersion', <any>showExactVersion) as any || formParams;
        }
        if (subfoldername !== undefined) {
            formParams = formParams.append('subfoldername', <any>subfoldername) as any || formParams;
        }
        if (useFileNameForCompress !== undefined) {
            formParams = formParams.append('useFileNameForCompress', <any>useFileNameForCompress) as any || formParams;
        }
        if (userGroup !== undefined) {
            formParams = formParams.append('userGroup', <any>userGroup) as any || formParams;
        }
        if (userName !== undefined) {
            formParams = formParams.append('userName', <any>userName) as any || formParams;
        }
        if (userType !== undefined) {
            formParams = formParams.append('userType', <any>userType) as any || formParams;
        }
        if (version !== undefined) {
            formParams = formParams.append('version', <any>version) as any || formParams;
        }
        if (year !== undefined) {
            formParams = formParams.append('year', <any>year) as any || formParams;
        }
        if (additionalinfo !== undefined) {
            formParams = formParams.append('additionalinfo', <any>additionalinfo) as any || formParams;
        }
        if (isDisclosable !== undefined) {
            formParams = formParams.append('isDisclosable', <any>isDisclosable) as any || formParams;
        }
        if (appusercreatorfullname !== undefined) {
            formParams = formParams.append('appusercreatorfullname', <any>appusercreatorfullname) as any || formParams;
        }
        if (appusermodifybyfullname !== undefined) {
            formParams = formParams.append('appusermodifybyfullname', <any>appusermodifybyfullname) as any || formParams;
        }
        if (complainantname !== undefined) {
            formParams = formParams.append('complainantname', <any>complainantname) as any || formParams;
        }
        if (content !== undefined) {
            formParams = formParams.append('content', <any>content) as any || formParams;
        }
        if (mimetype !== undefined) {
            formParams = formParams.append('mimetype', <any>mimetype) as any || formParams;
        }
        if (copyfoldername !== undefined) {
            formParams = formParams.append('copyfoldername', <any>copyfoldername) as any || formParams;
        }
        if (destinationfoldername !== undefined) {
            formParams = formParams.append('destinationfoldername', <any>destinationfoldername) as any || formParams;
        }
        if (emailDisable !== undefined) {
            formParams = formParams.append('emailDisable', <any>emailDisable) as any || formParams;
        }
        if (encryption !== undefined) {
            formParams = formParams.append('encryption', <any>encryption) as any || formParams;
        }
        if (fedRelatedDateStr !== undefined) {
            formParams = formParams.append('fedRelatedDateStr', <any>fedRelatedDateStr) as any || formParams;
        }
        if (fepaofficecode !== undefined) {
            formParams = formParams.append('fepaofficecode', <any>fepaofficecode) as any || formParams;
        }
        if (foldernewname !== undefined) {
            formParams = formParams.append('foldernewname', <any>foldernewname) as any || formParams;
        }
        if (numofindref !== undefined) {
            formParams = formParams.append('numofindref', <any>numofindref) as any || formParams;
        }
        if (relatedDateStr !== undefined) {
            formParams = formParams.append('relatedDateStr', <any>relatedDateStr) as any || formParams;
        }
        if (releaseToIndicator !== undefined) {
            formParams = formParams.append('releaseToIndicator', <any>releaseToIndicator) as any || formParams;
        }
        if (title !== undefined) {
            formParams = formParams.append('title', <any>title) as any || formParams;
        }
        if (useremail !== undefined) {
            formParams = formParams.append('useremail', <any>useremail) as any || formParams;
        }
        if (userfirstname !== undefined) {
            formParams = formParams.append('userfirstname', <any>userfirstname) as any || formParams;
        }
        if (userlastname !== undefined) {
            formParams = formParams.append('userlastname', <any>userlastname) as any || formParams;
        }
        if (responseDueDate !== undefined) {
            formParams = formParams.append('responseDueDate', <any>responseDueDate) as any || formParams;
        }
        if (userEmail !== undefined) {
            formParams = formParams.append('userEmail', <any>userEmail) as any || formParams;
        }
        if (federalRequest !== undefined) {
            formParams = formParams.append('federalRequest', <any>federalRequest) as any || formParams;
        }
        if (destinationFolderName !== undefined) {
            formParams = formParams.append('destinationFolderName', <any>destinationFolderName) as any || formParams;
        }
        if (applicationUserLastModifyByFullName !== undefined) {
            formParams = formParams.append('applicationUserLastModifyByFullName', <any>applicationUserLastModifyByFullName) as any || formParams;
        }
        if (complainantName !== undefined) {
            formParams = formParams.append('complainantName', <any>complainantName) as any || formParams;
        }
        if (userFirstName !== undefined) {
            formParams = formParams.append('userFirstName', <any>userFirstName) as any || formParams;
        }
        if (userLastName !== undefined) {
            formParams = formParams.append('userLastName', <any>userLastName) as any || formParams;
        }
        if (privateRequest !== undefined) {
            formParams = formParams.append('privateRequest', <any>privateRequest) as any || formParams;
        }
        if (privateOrFepaRequest !== undefined) {
            formParams = formParams.append('privateOrFepaRequest', <any>privateOrFepaRequest) as any || formParams;
        }
        if (systemicRequest !== undefined) {
            formParams = formParams.append('systemicRequest', <any>systemicRequest) as any || formParams;
        }
        if (emaildisable !== undefined) {
            formParams = formParams.append('emaildisable', <any>emaildisable) as any || formParams;
        }
        if (prirelatedatestr !== undefined) {
            formParams = formParams.append('prirelatedatestr', <any>prirelatedatestr) as any || formParams;
        }
        if (releasetoindicator !== undefined) {
            formParams = formParams.append('releasetoindicator', <any>releasetoindicator) as any || formParams;
        }
        if (applicationName !== undefined) {
            formParams = formParams.append('applicationName', <any>applicationName) as any || formParams;
        }
        if (username !== undefined) {
            formParams = formParams.append('username', <any>username) as any || formParams;
        }
        if (eeocTrackingNumber !== undefined) {
            formParams = formParams.append('eeocTrackingNumber', <any>eeocTrackingNumber) as any || formParams;
        }
        if (domainName !== undefined) {
            formParams = formParams.append('domainName', <any>domainName) as any || formParams;
        }
        if (subCategory !== undefined) {
            formParams = formParams.append('subCategory', <any>subCategory) as any || formParams;
        }
        if (agencyCode !== undefined) {
            formParams = formParams.append('agencyCode', <any>agencyCode) as any || formParams;
        }
        if (federal !== undefined) {
            formParams = formParams.append('federal', <any>federal) as any || formParams;
        }
        if (agencyCaseNumber !== undefined) {
            formParams = formParams.append('agencyCaseNumber', <any>agencyCaseNumber) as any || formParams;
        }
        if (creationDateRange !== undefined) {
            formParams = formParams.append('creationDateRange', <any>creationDateRange) as any || formParams;
        }
        if (tabType !== undefined) {
            formParams = formParams.append('tabType', <any>tabType) as any || formParams;
        }
        if (accountableOfficeCode !== undefined) {
            formParams = formParams.append('accountableOfficeCode', <any>accountableOfficeCode) as any || formParams;
        }
        if (searchKeyWord !== undefined) {
            formParams = formParams.append('searchKeyWord', <any>searchKeyWord) as any || formParams;
        }
        if (subFolderName !== undefined) {
            formParams = formParams.append('subFolderName', <any>subFolderName) as any || formParams;
        }
        if (md715OrForm462 !== undefined) {
            formParams = formParams.append('md715OrForm462', <any>md715OrForm462) as any || formParams;
        }
        if (application !== undefined) {
            formParams = formParams.append('application', <any>application) as any || formParams;
        }
        if (doccategory !== undefined) {
            formParams = formParams.append('doccategory', <any>doccategory) as any || formParams;
        }
        if (securitycode !== undefined) {
            formParams = formParams.append('securitycode', <any>securitycode) as any || formParams;
        }
        if (usergroup !== undefined) {
            formParams = formParams.append('usergroup', <any>usergroup) as any || formParams;
        }
        if (usertype !== undefined) {
            formParams = formParams.append('usertype', <any>usertype) as any || formParams;
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.put<object>(`${this.configuration.basePath}/v3/documents/retract/${encodeURIComponent(String(docid))}`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param docid 
     * @param appname 
     * @param domain 
     * @param useremail 
     * @param userfirstname 
     * @param userlastname 
     * @param acctoffice 
     * @param addversion 
     * @param agency 
     * @param getdocid 
     * @param doctype 
     * @param documentCategory 
     * @param filename 
     * @param foldername 
     * @param isfepa 
     * @param islogactivity 
     * @param ispub 
     * @param notes 
     * @param securityCode 
     * @param showAllVersions 
     * @param showExactVersion 
     * @param subfoldername 
     * @param useFileNameForCompress 
     * @param userGroup 
     * @param userName 
     * @param userType 
     * @param version 
     * @param year 
     * @param additionalinfo 
     * @param isDisclosable 
     * @param appusercreatorfullname 
     * @param appusermodifybyfullname 
     * @param complainantname 
     * @param content 
     * @param mimetype 
     * @param copyfoldername 
     * @param destinationfoldername 
     * @param emailDisable 
     * @param encryption 
     * @param fedRelatedDateStr 
     * @param fepaofficecode 
     * @param foldernewname 
     * @param numofindref 
     * @param relatedDateStr 
     * @param releaseToIndicator 
     * @param title 
     * @param responseDueDate 
     * @param userEmail 
     * @param federalRequest 
     * @param destinationFolderName 
     * @param applicationUserLastModifyByFullName 
     * @param complainantName 
     * @param userFirstName 
     * @param userLastName 
     * @param privateRequest 
     * @param privateOrFepaRequest 
     * @param systemicRequest 
     * @param emaildisable 
     * @param prirelatedatestr 
     * @param releasetoindicator 
     * @param applicationName 
     * @param username 
     * @param eeocTrackingNumber 
     * @param domainName 
     * @param subCategory 
     * @param agencyCode 
     * @param federal 
     * @param agencyCaseNumber 
     * @param creationDateRange 
     * @param tabType 
     * @param accountableOfficeCode 
     * @param searchKeyWord 
     * @param subFolderName 
     * @param md715OrForm462 
     * @param application 
     * @param doccategory 
     * @param securitycode 
     * @param usergroup 
     * @param usertype 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateDocument(docid: string, appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<object>;
    public updateDocument(docid: string, appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<object>>;
    public updateDocument(docid: string, appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<object>>;
    public updateDocument(docid: string, appname: string, domain: string, useremail: string, userfirstname: string, userlastname: string, acctoffice?: string, addversion?: string, agency?: string, getdocid?: string, doctype?: string, documentCategory?: string, filename?: string, foldername?: string, isfepa?: string, islogactivity?: boolean, ispub?: string, notes?: string, securityCode?: string, showAllVersions?: string, showExactVersion?: string, subfoldername?: string, useFileNameForCompress?: string, userGroup?: string, userName?: string, userType?: string, version?: string, year?: string, additionalinfo?: string, isDisclosable?: boolean, appusercreatorfullname?: string, appusermodifybyfullname?: string, complainantname?: string, content?: Blob, mimetype?: string, copyfoldername?: string, destinationfoldername?: string, emailDisable?: string, encryption?: string, fedRelatedDateStr?: string, fepaofficecode?: string, foldernewname?: string, numofindref?: number, relatedDateStr?: string, releaseToIndicator?: string, title?: string, responseDueDate?: Date, userEmail?: string, federalRequest?: boolean, destinationFolderName?: string, applicationUserLastModifyByFullName?: string, complainantName?: string, userFirstName?: string, userLastName?: string, privateRequest?: boolean, privateOrFepaRequest?: boolean, systemicRequest?: boolean, emaildisable?: string, prirelatedatestr?: string, releasetoindicator?: string, applicationName?: string, username?: string, eeocTrackingNumber?: string, domainName?: string, subCategory?: string, agencyCode?: string, federal?: boolean, agencyCaseNumber?: string, creationDateRange?: string, tabType?: string, accountableOfficeCode?: string, searchKeyWord?: string, subFolderName?: string, md715OrForm462?: boolean, application?: string, doccategory?: string, securitycode?: string, usergroup?: string, usertype?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {
        if (docid === null || docid === undefined) {
            throw new Error('Required parameter docid was null or undefined when calling updateDocument.');
        }
        if (appname === null || appname === undefined) {
            throw new Error('Required parameter appname was null or undefined when calling updateDocument.');
        }
        if (domain === null || domain === undefined) {
            throw new Error('Required parameter domain was null or undefined when calling updateDocument.');
        }
        if (useremail === null || useremail === undefined) {
            throw new Error('Required parameter useremail was null or undefined when calling updateDocument.');
        }
        if (userfirstname === null || userfirstname === undefined) {
            throw new Error('Required parameter userfirstname was null or undefined when calling updateDocument.');
        }
        if (userlastname === null || userlastname === undefined) {
            throw new Error('Required parameter userlastname was null or undefined when calling updateDocument.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: this.encoder});
        }

        if (acctoffice !== undefined) {
            formParams = formParams.append('acctoffice', <any>acctoffice) as any || formParams;
        }
        if (addversion !== undefined) {
            formParams = formParams.append('addversion', <any>addversion) as any || formParams;
        }
        if (agency !== undefined) {
            formParams = formParams.append('agency', <any>agency) as any || formParams;
        }
        if (appname !== undefined) {
            formParams = formParams.append('appname', <any>appname) as any || formParams;
        }
        if (getdocid !== undefined) {
            formParams = formParams.append('getdocid', <any>getdocid) as any || formParams;
        }
        if (doctype !== undefined) {
            formParams = formParams.append('doctype', <any>doctype) as any || formParams;
        }
        if (documentCategory !== undefined) {
            formParams = formParams.append('documentCategory', <any>documentCategory) as any || formParams;
        }
        if (domain !== undefined) {
            formParams = formParams.append('domain', <any>domain) as any || formParams;
        }
        if (filename !== undefined) {
            formParams = formParams.append('filename', <any>filename) as any || formParams;
        }
        if (foldername !== undefined) {
            formParams = formParams.append('foldername', <any>foldername) as any || formParams;
        }
        if (isfepa !== undefined) {
            formParams = formParams.append('isfepa', <any>isfepa) as any || formParams;
        }
        if (islogactivity !== undefined) {
            formParams = formParams.append('islogactivity', <any>islogactivity) as any || formParams;
        }
        if (ispub !== undefined) {
            formParams = formParams.append('ispub', <any>ispub) as any || formParams;
        }
        if (notes !== undefined) {
            formParams = formParams.append('notes', <any>notes) as any || formParams;
        }
        if (securityCode !== undefined) {
            formParams = formParams.append('securityCode', <any>securityCode) as any || formParams;
        }
        if (showAllVersions !== undefined) {
            formParams = formParams.append('showAllVersions', <any>showAllVersions) as any || formParams;
        }
        if (showExactVersion !== undefined) {
            formParams = formParams.append('showExactVersion', <any>showExactVersion) as any || formParams;
        }
        if (subfoldername !== undefined) {
            formParams = formParams.append('subfoldername', <any>subfoldername) as any || formParams;
        }
        if (useFileNameForCompress !== undefined) {
            formParams = formParams.append('useFileNameForCompress', <any>useFileNameForCompress) as any || formParams;
        }
        if (userGroup !== undefined) {
            formParams = formParams.append('userGroup', <any>userGroup) as any || formParams;
        }
        if (userName !== undefined) {
            formParams = formParams.append('userName', <any>userName) as any || formParams;
        }
        if (userType !== undefined) {
            formParams = formParams.append('userType', <any>userType) as any || formParams;
        }
        if (version !== undefined) {
            formParams = formParams.append('version', <any>version) as any || formParams;
        }
        if (year !== undefined) {
            formParams = formParams.append('year', <any>year) as any || formParams;
        }
        if (additionalinfo !== undefined) {
            formParams = formParams.append('additionalinfo', <any>additionalinfo) as any || formParams;
        }
        if (isDisclosable !== undefined) {
            formParams = formParams.append('isDisclosable', <any>isDisclosable) as any || formParams;
        }
        if (appusercreatorfullname !== undefined) {
            formParams = formParams.append('appusercreatorfullname', <any>appusercreatorfullname) as any || formParams;
        }
        if (appusermodifybyfullname !== undefined) {
            formParams = formParams.append('appusermodifybyfullname', <any>appusermodifybyfullname) as any || formParams;
        }
        if (complainantname !== undefined) {
            formParams = formParams.append('complainantname', <any>complainantname) as any || formParams;
        }
        if (content !== undefined) {
            formParams = formParams.append('content', <any>content) as any || formParams;
        }
        if (mimetype !== undefined) {
            formParams = formParams.append('mimetype', <any>mimetype) as any || formParams;
        }
        if (copyfoldername !== undefined) {
            formParams = formParams.append('copyfoldername', <any>copyfoldername) as any || formParams;
        }
        if (destinationfoldername !== undefined) {
            formParams = formParams.append('destinationfoldername', <any>destinationfoldername) as any || formParams;
        }
        if (emailDisable !== undefined) {
            formParams = formParams.append('emailDisable', <any>emailDisable) as any || formParams;
        }
        if (encryption !== undefined) {
            formParams = formParams.append('encryption', <any>encryption) as any || formParams;
        }
        if (fedRelatedDateStr !== undefined) {
            formParams = formParams.append('fedRelatedDateStr', <any>fedRelatedDateStr) as any || formParams;
        }
        if (fepaofficecode !== undefined) {
            formParams = formParams.append('fepaofficecode', <any>fepaofficecode) as any || formParams;
        }
        if (foldernewname !== undefined) {
            formParams = formParams.append('foldernewname', <any>foldernewname) as any || formParams;
        }
        if (numofindref !== undefined) {
            formParams = formParams.append('numofindref', <any>numofindref) as any || formParams;
        }
        if (relatedDateStr !== undefined) {
            formParams = formParams.append('relatedDateStr', <any>relatedDateStr) as any || formParams;
        }
        if (releaseToIndicator !== undefined) {
            formParams = formParams.append('releaseToIndicator', <any>releaseToIndicator) as any || formParams;
        }
        if (title !== undefined) {
            formParams = formParams.append('title', <any>title) as any || formParams;
        }
        if (useremail !== undefined) {
            formParams = formParams.append('useremail', <any>useremail) as any || formParams;
        }
        if (userfirstname !== undefined) {
            formParams = formParams.append('userfirstname', <any>userfirstname) as any || formParams;
        }
        if (userlastname !== undefined) {
            formParams = formParams.append('userlastname', <any>userlastname) as any || formParams;
        }
        if (responseDueDate !== undefined) {
            formParams = formParams.append('responseDueDate', <any>responseDueDate) as any || formParams;
        }
        if (userEmail !== undefined) {
            formParams = formParams.append('userEmail', <any>userEmail) as any || formParams;
        }
        if (federalRequest !== undefined) {
            formParams = formParams.append('federalRequest', <any>federalRequest) as any || formParams;
        }
        if (destinationFolderName !== undefined) {
            formParams = formParams.append('destinationFolderName', <any>destinationFolderName) as any || formParams;
        }
        if (applicationUserLastModifyByFullName !== undefined) {
            formParams = formParams.append('applicationUserLastModifyByFullName', <any>applicationUserLastModifyByFullName) as any || formParams;
        }
        if (complainantName !== undefined) {
            formParams = formParams.append('complainantName', <any>complainantName) as any || formParams;
        }
        if (userFirstName !== undefined) {
            formParams = formParams.append('userFirstName', <any>userFirstName) as any || formParams;
        }
        if (userLastName !== undefined) {
            formParams = formParams.append('userLastName', <any>userLastName) as any || formParams;
        }
        if (privateRequest !== undefined) {
            formParams = formParams.append('privateRequest', <any>privateRequest) as any || formParams;
        }
        if (privateOrFepaRequest !== undefined) {
            formParams = formParams.append('privateOrFepaRequest', <any>privateOrFepaRequest) as any || formParams;
        }
        if (systemicRequest !== undefined) {
            formParams = formParams.append('systemicRequest', <any>systemicRequest) as any || formParams;
        }
        if (emaildisable !== undefined) {
            formParams = formParams.append('emaildisable', <any>emaildisable) as any || formParams;
        }
        if (prirelatedatestr !== undefined) {
            formParams = formParams.append('prirelatedatestr', <any>prirelatedatestr) as any || formParams;
        }
        if (releasetoindicator !== undefined) {
            formParams = formParams.append('releasetoindicator', <any>releasetoindicator) as any || formParams;
        }
        if (applicationName !== undefined) {
            formParams = formParams.append('applicationName', <any>applicationName) as any || formParams;
        }
        if (username !== undefined) {
            formParams = formParams.append('username', <any>username) as any || formParams;
        }
        if (eeocTrackingNumber !== undefined) {
            formParams = formParams.append('eeocTrackingNumber', <any>eeocTrackingNumber) as any || formParams;
        }
        if (domainName !== undefined) {
            formParams = formParams.append('domainName', <any>domainName) as any || formParams;
        }
        if (subCategory !== undefined) {
            formParams = formParams.append('subCategory', <any>subCategory) as any || formParams;
        }
        if (agencyCode !== undefined) {
            formParams = formParams.append('agencyCode', <any>agencyCode) as any || formParams;
        }
        if (federal !== undefined) {
            formParams = formParams.append('federal', <any>federal) as any || formParams;
        }
        if (agencyCaseNumber !== undefined) {
            formParams = formParams.append('agencyCaseNumber', <any>agencyCaseNumber) as any || formParams;
        }
        if (creationDateRange !== undefined) {
            formParams = formParams.append('creationDateRange', <any>creationDateRange) as any || formParams;
        }
        if (tabType !== undefined) {
            formParams = formParams.append('tabType', <any>tabType) as any || formParams;
        }
        if (accountableOfficeCode !== undefined) {
            formParams = formParams.append('accountableOfficeCode', <any>accountableOfficeCode) as any || formParams;
        }
        if (searchKeyWord !== undefined) {
            formParams = formParams.append('searchKeyWord', <any>searchKeyWord) as any || formParams;
        }
        if (subFolderName !== undefined) {
            formParams = formParams.append('subFolderName', <any>subFolderName) as any || formParams;
        }
        if (md715OrForm462 !== undefined) {
            formParams = formParams.append('md715OrForm462', <any>md715OrForm462) as any || formParams;
        }
        if (application !== undefined) {
            formParams = formParams.append('application', <any>application) as any || formParams;
        }
        if (doccategory !== undefined) {
            formParams = formParams.append('doccategory', <any>doccategory) as any || formParams;
        }
        if (securitycode !== undefined) {
            formParams = formParams.append('securitycode', <any>securitycode) as any || formParams;
        }
        if (usergroup !== undefined) {
            formParams = formParams.append('usergroup', <any>usergroup) as any || formParams;
        }
        if (usertype !== undefined) {
            formParams = formParams.append('usertype', <any>usertype) as any || formParams;
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.put<object>(`${this.configuration.basePath}/v3/documents/${encodeURIComponent(String(docid))}`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
